export default "__VITE_ASSET__D_x5IuiT__"